import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const TileSubText: FunctionComponent<Props> = props => {
    const { children = props.text, className = '', testId = TEST_ID, title } = props;

    return (
        <p className={`${className} ${styles.tileSubText}`} data-testid={testId} title={title}>
            {children}
        </p>
    );
};

export default TileSubText;
